module.exports = __webpack_public_path__ + "avatar-slk.883eb1f5.png";